import { Grid } from '@material-ui/core';
import Grow from '@material-ui/core/Grow';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import React, { Component } from 'react';
import {
    Button,
    InputText,
    Form,
    FormControl,
    FormCheckbox,
    Snackbar,
    VSpacer
} from 'sm-react-components';
import mixpanel, { Events as MPEvents } from '../../infrastructure/mixpanel';
import {
    registerUser,
    resendValidationMail
} from '../../infrastructure/requests';
import * as routes from '../../infrastructure/routemap';
import Link from '../components/Link';

const styles = theme => ({
    button: {
        width: '100%'
    },
    buttons: {
        width: '120px'
    },
    termsContainer: {
        display: 'inline-flex',
        marginTop: '5px',
        marginBottom: '14px'
    },
    termsLabel: {
        fontSize: '12px',
        color: '#838A9A',
        marginLeft: '5px'
    },
    snackbarRoot: {
        top: '-10%'
    }
});

class RegisterContainer extends Component {
  state = {
      page: 1,
      firstName: '',
      lastName: '',
      email: '',
      company: '',
      phoneNumber: '',
      password: '',
      error: undefined,
      ready: false,
      done: false,
      terms: false,
      snackbarOpen: false
  };

  handleRegister = async () => {
      const {
          email,
          password,
          firstName,
          lastName,
          company,
          phoneNumber
      } = this.state;
      try {
          await registerUser(
              email,
              password,
              firstName,
              lastName,
              company,
              phoneNumber
          );
          mixpanel.track(MPEvents.HOME_CREATE_ACCOUNT, { firstName, email });
          this.setState({ done: true });
      } catch (error) {
          this.setState({
              error: error.message,
              page: 1,
              terms: false,
              snackbarOpen: true
          });
      }
  };

  handleResendMail = () => {
      const { email } = this.state;
      mixpanel.track(MPEvents.USER_RESEND_VERIFICATION_MAIL, { email });
      resendValidationMail(email)
          .then(() =>
              mixpanel.track(MPEvents.HOME_CREATE_ACCOUNT_RESEND, { email })
          )
          .catch(error =>
              this.setState({ error: error.message, snackbarOpen: true })
          );
  };

  handleChange = name => value => {
      this.setState({
          [name]: value
      });
  };

  handleCheckboxChange = event => {
      this.setState(
          {
              target: event.target.value
          },
          () => {
              this.validateFirst();
              this.validateSecond();
          }
      );
  };

  firstpage = () => {
      const { company, email, password } = this.state;
      const { classes } = this.props;
      return (
          <Form
              lazyValidation
              onSubmit={() => this.setState({ page: 2 })}
              direction="column"
          >
              <InputText
                  id="email"
                  type="email"
                  label="Email"
                  value={email}
                  onChange={this.handleChange('email')}
                  margin="none"
                  className={classes.field}
                  validators={['required', 'email']}
              />
              <InputText
                  id="password"
                  type="password"
                  label="Password"
                  value={password}
                  onChange={this.handleChange('password')}
                  margin="none"
                  className={classes.field}
                  validators={['required']}
                  customValidator={text => {
                      if (text.length < 8) {
                          return 'Text must contain at least 8 characters';
                      }
                      return undefined;
                  }}
              />
              <InputText
                  id="company"
                  label="Company (optional)"
                  value={company}
                  onChange={this.handleChange('company')}
                  margin="none"
                  className={classes.field}
                  validators={[]}
              />
              <VSpacer />
              <FormControl>
                  <Button type="submit" className={classes.button}>
            Next
                  </Button>
              </FormControl>
          </Form>
      );
  };

  secondpage = () => {
      const { firstName, lastName, terms } = this.state;
      const { classes } = this.props;
      return (
          <Form lazyValidation onSubmit={this.handleRegister} direction="column">
              <InputText
                  id="firstName"
                  type="text"
                  label="First Name"
                  value={firstName}
                  onChange={this.handleChange('firstName')}
                  margin="none"
                  className={classes.field}
                  validators={['required']}
              />
              <InputText
                  id="lastName"
                  type="text"
                  label="Last Name"
                  value={lastName}
                  onChange={this.handleChange('lastName')}
                  margin="none"
                  className={classes.field}
                  validators={['required']}
              />
              <InputText
                  id="phoneNumber"
                  type="text"
                  label="Phone Number"
                  onChange={this.handleChange('phoneNumber')}
                  margin="none"
                  className={classes.field}
              />
              <FormCheckbox
                  checked={terms}
                  onChange={val => this.setState({ terms: val })}
                  labelComponent={
                      <Typography className={classes.termsAndConditions}>
              I've reviewed and agreed to all of the{' '}
                          <a
                              href={'https://www.smartmonkey.io/terms'}
                              target="_blank"
                              rel="noopener noreferrer"
                          >
                Terms and Conditions
                          </a>
                      </Typography>
                  }
                  validators={['isTrue']}
                  errorMessages={[
                      'You must accept the Terms and Conditions to register'
                  ]}
              />
              <VSpacer small />
              <FormControl
                  alignItems="center"
                  direction="row"
                  justify="space-between"
              >
                  <Button
                      disabled={false}
                      color="secondary"
                      variant={'text'}
                      className={classes.buttons}
                      onClick={() => this.setState({ page: 1 })}
                  >
            Back
                  </Button>
                  <Button type="submit" className={classes.buttons}>
            Register
                  </Button>
              </FormControl>
          </Form>
      );
  };

  donepage = () => {
      const { classes } = this.props;
      const { email } = this.state;
      return (
          <Grid container direction="column">
              <Grid item>
                  <Typography>
            A verification email has been sent to the adress:
                  </Typography>
                  <VSpacer />
                  <Typography align="center">
                      <b>{email}</b>
                  </Typography>
                  <VSpacer />
                  <Typography>
            Please follow the link inside the mail to verify your account.
                  </Typography>
                  <VSpacer />
                  <Typography>Didn't recieve the mail?</Typography>
                  <VSpacer small />
                  <Button className={classes.button} onClick={this.handleResendMail}>
            Resend Email
                  </Button>
              </Grid>
          </Grid>
      );
  };

  render() {
      const { done, error, page, snackbarOpen } = this.state;
      const { classes, clear } = this.props;
      return (
          <Grid
              container
              direction="column"
              justify="space-between"
              style={{ height: '100%' }}
          >
              <Snackbar
                  variant="error"
                  open={snackbarOpen}
                  onClose={() => this.setState({ snackbarOpen: false })}
                  autoHideDuration={3000}
                  closeByClickAway
                  horizontal="center"
                  vertical="top"
                  message={error}
                  classes={{ anchorOriginTopCenter: classes.snackbarRoot }}
              />
              {!clear && !done && (
                  <Grid item>
                      <Typography color="textSecondary" variant="h5">
              Register
                      </Typography>
                  </Grid>
              )}
              {!done && (
              // Create the animations
                  <React.Fragment>
                      <Grow
                          in={page === 1}
                          mountOnEnter
                          unmountOnExit
                          timeout={{ enter: 300, exit: 0 }}
                      >
                          {this.firstpage()}
                      </Grow>
                      <Grow
                          in={page === 2}
                          mountOnEnter
                          unmountOnExit
                          timeout={{ enter: 300, exit: 0 }}
                      >
                          {this.secondpage()}
                      </Grow>
                      {!clear && (
                          <Grid item>
                              <Typography component="span">
                                  <Link to={routes.login}>Already have an account?</Link>
                              </Typography>
                          </Grid>
                      )}
                  </React.Fragment>
              )}
              {done && (
                  <React.Fragment>
                      <Grid item>
                          <Typography color="textSecondary" variant="h5">
                Register
                          </Typography>
                          <VSpacer medium />
                          {this.donepage()}
                      </Grid>
                      <Grid item>
                          <Typography component="span">
                              <Link to={routes.login}>Already have an account?</Link>
                          </Typography>
                      </Grid>
                  </React.Fragment>
              )}
          </Grid>
      );
  }
}

export default withStyles(styles)(RegisterContainer);
